import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Ship = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M10.954 15.24 10.57 20l1.253-.214c.125-.022 3.089-.544 5.15-2.461.97-.9 1.043-1.76 1.128-2.753.06-.699.132-1.559.506-2.854 3.828-3.687 3.382-8.731 3.374-8.817l-.082-.8-.8-.082h-.006c-.212-.017-5.171-.406-8.812 3.376-1.294.373-2.153.446-2.85.505-.996.084-1.855.157-2.756 1.127-1.917 2.062-2.44 5.026-2.46 5.151L4 13.43l4.76-.384a2.883 2.883 0 0 0 2.52-2.022c1.938-6.13 6.768-6.973 8.754-7.054-.07 1.987-.898 6.803-7.058 8.75a2.884 2.884 0 0 0-2.022 2.52ZM9.648 7.862c.26-.022.552-.048.883-.09a14.286 14.286 0 0 0-1.133 2.656.918.918 0 0 1-.795.649l-2.1.17c.293-.861.799-1.997 1.617-2.878.37-.397.574-.426 1.475-.502l.053-.005Zm3.922 6.738c1-.315 1.88-.7 2.657-1.132-.045.353-.072.66-.094.934-.077.902-.108 1.107-.506 1.476-.88.818-2.015 1.326-2.874 1.618l.17-2.098a.92.92 0 0 1 .647-.798Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M2.167 20.54 1 23l2.46-1.168c.462-.22 4.54-2.172 5.71-3.342.346-.348.754-1.072.83-1.844l-1.931-.191a1.413 1.413 0 0 1-.272.663c-.386.385-1.413 1.006-2.53 1.615.609-1.117 1.229-2.144 1.615-2.53.082-.078.391-.246.66-.272L7.357 14c-.772.075-1.498.483-1.846.83-1.17 1.17-3.123 5.247-3.343 5.71Z"
      fill="currentColor"
    />
  </Icon>
));

export default Ship;
